import api from 'src/configs/api';
import qs from 'qs';
import { TProductDto, TProductFilterRequest, TProductItem } from 'src/types/Products/product.model';
import { TBaseResponse, TFilterResponse } from 'src/types/Commons/filter.model';
import { TOption } from 'src/types/Commons/option.model';

const prefix = 'api/product';
export async function getProducts(params:TProductFilterRequest) {
    const query = qs.stringify(params);
  const res = await api.get<TBaseResponse<TFilterResponse<TProductItem>>>(`${prefix}/products?${query}`);
  return res.data;
}

export async function getUnits() {
  const res = await api.get<TBaseResponse<TOption[]>>(`${prefix}/units`);
  return res.data;
}

export async function getBranchs() {
  const res = await api.get<TBaseResponse<TOption[]>>(`${prefix}/branchs`);
  return res.data;
}
export async function getCategories() {
    const res = await api.get<TBaseResponse<TOption[]>>(`${prefix}/categories`);
    return res.data;
  }
  export async function getProductById(id:number) {
    const res = await api.get<TBaseResponse<TProductDto>>(`${prefix}/product/`+id);
    return res.data;
  }
  export async function createProduct(product:TProductDto) {
    const res = await api.post<TBaseResponse<number>>(`${prefix}/product/`,product);
    return res.data;
  }
  export async function updateProduct(product:TProductDto) {
    const res = await api.put<TBaseResponse<number>>(`${prefix}/product/`,product);
    return res.data;
  }